import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {Country} from '../../kf-data-entry/models/country.interface';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {DownloadDataSearchInterface} from '../models/download-data-search.interface';
import {WeeeSystems} from '../../admin/models/weee_systems.interface';


const COUNTRIES_API = environment.apiUrl + 'countries';
const WEEESYSTEMS_API = environment.apiUrl + 'weeesystems';
const REPORT_CYCLES_API = environment.apiUrl + 'report-cycles';
const CHARTS_API = environment.apiUrl + 'charts';
const INTELLIGENCE_API = environment.apiUrl + 'intelligence';
const INTELLIGENCE_DATA_API = environment.apiUrl + 'intelligencedata/answerforms';

@Injectable({
  providedIn: 'root'
})
export class DownloadDataService {

  static buildSearchParams(search: DownloadDataSearchInterface): string {
    let searchParams = '';
    if (search.years && search.years.length > 0) {
      // search.years.forEach(year => searchParams += `?years=${year}`);
      searchParams += `?years=${search.years}`;
    }
    if (search.countries && search.countries.length > 0) {
      (searchParams === '') ? searchParams += '?' : searchParams += '&';
      // search.countries.forEach(country => searchParams += `countries=${country}`);
      searchParams += `countries=${search.countries}`;
    }
    if (search.weeeSystems && search.weeeSystems.length > 0) {
      (searchParams === '') ? searchParams += '?' : searchParams += '&';
      searchParams += `weeeSystems=${search.weeeSystems}`;
    }

    return searchParams;
  }

  constructor(private http: HttpClient) { }


  getAllCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(`${COUNTRIES_API}/all`);
  }

  getAllWeeeSystems(): Observable<WeeeSystems[]> {
    return this.http.get<WeeeSystems[]>(`${WEEESYSTEMS_API}/all`);
  }

  getAllYears(): Observable<number[]> {
    return this.http.get<number[]>(`${REPORT_CYCLES_API}/years`);
  }


  downloadExcel(search: DownloadDataSearchInterface): Observable<any> {
    return this.http.get(`${CHARTS_API}/download-data${DownloadDataService.buildSearchParams(search)}`, {
      observe: 'response',
      responseType: 'blob'
    });
  }


  downloadIntelligenceExcel(search: DownloadDataSearchInterface): Observable<any> {
    let url = `${INTELLIGENCE_API}/download-data?year=${search.years}`;
    if (search.countries && search.countries.length > 0) {
      url += `&countries=${search.countries}`;
    }
    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  downloadIntelligenceDataExcel(search: DownloadDataSearchInterface): Observable<any> {
    return this.http.get(`${INTELLIGENCE_DATA_API}/download-data${DownloadDataService.buildSearchParams(search)}`, {
      observe: 'response',
      responseType: 'blob'
    });
  }
}
